import Jets from 'jets';

const selectors = {
	input: '',
	content: ''
};
let elements;
const INPUT = 'input';
const CLICK = 'click';
const TOUCHSTART = 'touchstart';
let inputHandler;
let clickHandler;
let touchstartHandler;
let bodyHandler;
let bodyElm;
let jetsSearch;

function setupJets(inputSelector, contentWrapSelector) {
	const jets = new Jets({
		searchTag: inputSelector,
		contentTag: contentWrapSelector
	});
	return jets;
}

function addHandler(elm, type, cb, capture) {
	const handler = function handler(e) {
		if (cb) {
			cb(e);
		}
	};
	elm.addEventListener(type, handler, capture);
	return handler;
}

export default {
	init(p) {
		/* initialize with selectors for search-input-field and content-wrapper,
		 * currently for example with '.search .search__input', and '#section2 .game-grid'
		 * forother requirements and settings: see the imported module 'Jets' */
		selectors.input = p.input;
		selectors.content = p.content;
		/*
		TODO: create all elements dynamically to quit the dependency on selectors
		* then only provide the contentWrapSelector, and the module using this
		* module may insert the wrapping element
		*/
		const wrap = document.querySelector('.search'); // see mustache file header.mustache
		const input = document.querySelector(selectors.input); // this element is created in mustache, but can be generated dynamically to detach a dependency on the searchpath from the arguments
		const activeicon = document.querySelector('.search__search-lens'); // this element is created in mustache, but can be generated dynamically
		const clearicon = document.querySelector('.search__search-clear'); // this element is created in mustache, but can be generated dynamically
		const hide = 'u-hide';
		const expand = 'search--expanded';
		bodyElm = document.querySelector('body');
		elements = {
			wrap,
			input,
			activeicon,
			clearicon
		};

		function activateField() {
			elements.wrap.classList.add(expand);
			elements.activeicon.classList.remove(hide);
		}

		function deactivateField() {
			elements.wrap.classList.remove(expand);
			elements.activeicon.classList.add(hide);
		}
		function clearSearch() {
			/* update the search with empty value to display all items and clean the searchfield */
			elements.input.value = '';
			elements.input.focus();
			jetsSearch.search();
			clearicon.classList.add(hide);
		}

		function showClearicon(e) {
			window.lazySizes.loader.checkElems();
			if(!e.target.value){
				clearicon.classList.add(hide);
				return;
			}
			clearicon.classList.remove(hide);
		}

		function touchstartCb(e) {
			activateField();
			e.stopPropagation();
		}

		function bodytouchCb(e) {
			deactivateField();
		}

		// TODO: the touch-events may be completed to handler pointer-events and
		// later a desktop-solution may acivate the field without touch at all
		inputHandler = addHandler(elements.wrap, INPUT, showClearicon);
		clickHandler = addHandler(elements.clearicon, CLICK, clearSearch);
		touchstartHandler = addHandler(elements.wrap, TOUCHSTART, touchstartCb);
		bodyHandler = addHandler(bodyElm, TOUCHSTART, bodytouchCb);
	},
	setup() {
		if (jetsSearch) {
			jetsSearch.update();
		} else {
			jetsSearch = setupJets(selectors.input, selectors.content);
		}
	},
	close() {
		elements.wrap.removeEventListener(INPUT, inputHandler);
		elements.clearicon.removeEventListener(CLICK, clickHandler);
		elements.wrap.removeEventListener(TOUCHSTART, touchstartHandler);
		bodyElm.removeEventListener(TOUCHSTART, bodyHandler);
		jetsSearch = null;
	}

};



// WEBPACK FOOTER //
// ./mobile-core/src/casino/search.js